import { Injector, ModuleWithProviders, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { SharedModule } from 'app/shared/shared.module';
import { BryntumCoreModule } from '@bryntum/core-angular-thin';
import { BryntumGridModule } from '@bryntum/grid-angular-thin';
import { BryntumSchedulerModule } from '@bryntum/scheduler-angular-thin';
import { BryntumCalendarModule } from '@bryntum/calendar-angular-thin';
import { CalendarSettingsComponent } from './components/calendar-settings/calendar-settings.component';
import { CalendarSettingsCardComponent } from './components/calendar-settings-card/calendar-settings-card.component';
import { CalendarAttributePickerComponent } from './components/calendar-attribute-picker/calendar-attribute-picker.component';
import { CustomSliderComponent } from './components/custom-slider/custom-slider.component';
import { PreviewDataModule } from 'app/components/preview-data/preview-data.module';
import { NewJobModule } from 'app/components/new-job/new-job.module';
import { CalendarFilterComponent } from './components/calendar-filter/calendar-filter.component';
import { CalendarFilterDrawerComponent } from './components/calendar-filter-drawer/calendar-filter-drawer.component';
import { ManageCalendarFilterComponent } from './components/manage-calendar-filter/manage-calendar-filter.component';
import { CalendarShimmerEffectComponent } from './components/calendar-shimmer-effect/calendar-shimmer-effect.component';
import { CalendarComponent } from './components/calendar/calendar.component';
import { CreateNonJobEventModule } from 'app/components/create-non-job-event/create-non-job-event.module';
import { NonJobEventDetailsModule } from 'app/components/non-job-event-details/non-job-event-details.module';

const providers = [];

@NgModule({
  declarations: [
    AppComponent,
    CalendarComponent,
    CalendarSettingsComponent,
    CalendarSettingsCardComponent,
    CalendarAttributePickerComponent,
    CustomSliderComponent,
    CalendarFilterComponent,
    CalendarFilterDrawerComponent,
    ManageCalendarFilterComponent,
    CalendarShimmerEffectComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    SharedModule,
    BryntumCalendarModule,
    PreviewDataModule,
    NewJobModule,
    BryntumCoreModule,
    BryntumGridModule,
    BryntumSchedulerModule,
    BryntumCalendarModule,
    CreateNonJobEventModule,
    NonJobEventDetailsModule
  ],
  providers: providers,
  bootstrap: [AppComponent]
})

export class AppModule {
  // constructor(injector: Injector) {
  //   customElements.define('grid-shimmer', createCustomElement(GridShimmerComponent, { injector }));
  //   customElements.define('badge-template', createCustomElement(BadgeComponent, { injector }));
  // }
 }

@NgModule({})
export class CalendarSharedModule{
  static forRoot(): ModuleWithProviders<AppModule> {
    return {
      ngModule: AppModule,
      providers: providers
    };
  }
}
